/**
 * t411u: a maintenance or announcement banner set by the platform team in the admin centre (collab.platform_banners).
 * Shown to everyone in the chosen workspaces while it's live; dismissible for the session.
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';

export function PlatformBanner() {
  const ws = useWorkspaceId();
  const q = useQuery({ queryKey: ['platform-banner', ws ?? ''], queryFn: () => api.platformBanner(ws!), enabled: Boolean(ws), staleTime: 5 * 60_000, refetchInterval: 10 * 60_000, retry: 0 });
  const [hidden, setHidden] = useState<string | null>(() => sessionStorage.getItem('hub.platformBanner.hidden'));
  const b = q.data?.banner;
  if (!b || hidden === b.id) return null;
  return (
    <div role="status" data-testid="platform-banner"
      className="flex items-center justify-center gap-3 border-b border-slate-200 bg-slate-50 px-4 py-2 text-center text-sm text-slate-800 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-100">
      <span>{b.message}</span>
      <button type="button" aria-label="Hide this message" className="rounded p-0.5 text-slate-500 hover:text-slate-800 dark:hover:text-white"
        onClick={() => { sessionStorage.setItem('hub.platformBanner.hidden', b.id); setHidden(b.id); }}>
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
